// SupplierListTypes.ts

import { useCanAccessOnboarding } from "hooks/featureFlags";
import { SupplierList } from "newui/features/Rfx/types/rfx.types";

export enum SupplierListType {
	MySupplierList = 0,
	Panel = 1,
	Onboarding = 2,
}

export const SupplierListInfo: Record<
	SupplierListType,
	{ description: string; label: string; }
> = {
	[SupplierListType.Onboarding]: {
		label: "Onboard and Pre-qualify",
		description:
			"Onboard and pre-qualify your suppliers here, by inviting them to complete required documents (e.g. NDAs or Supplier Forms). This is not for RFx workflows.",
	},
	[SupplierListType.MySupplierList]: {
		label: "My Supplier Lists",
		description:
			"This Supplier List is less formal, used as a guideline for procurement, offers flexibility, and typically does not involve binding contracts. Also known as a Preferred Supplier List.",
	},
	[SupplierListType.Panel]: {
		label: "Panel List",
		description:
			"Panel (Admin Permissions Only)\nA Panel is more formal, involves a competitive process, suppliers are contractually engaged with a defined duration.",
	},
};

export const useSupplierListOptions = () => {
	const canAccessOnboarding = useCanAccessOnboarding();

	return Object.entries(SupplierListInfo)
		.filter(([key]) => {
			const listType = Number(key) as SupplierListType;
			if (listType === SupplierListType.Onboarding && !canAccessOnboarding) {
				return false;
			}
			return true;
		})
		.map(([key, { label }]) => ({
			label,
			value: Number(key),
		}));
};

export const getSupplierListType = (
	supplierList: SupplierList
): SupplierListType => {
	if (supplierList.is_company_approved_list) {
		return SupplierListType.Panel;
	}

	if (supplierList.is_onboarding) {
		return SupplierListType.Onboarding;
	}

	return SupplierListType.MySupplierList;
};

export const setSupplierListFlags = (
	supplierList: SupplierList,
	listType: SupplierListType
) => {
	return {
		...supplierList,
		is_onboarding: listType === SupplierListType.Onboarding,
		is_company_approved_list: listType === SupplierListType.Panel,
	} as SupplierList;
};
